import update from 'immutability-helper';
import { COUNT } from '@utils/metrics';
import * as types from './types';

const initialState = {
  dimensions: [],
  unit: COUNT,
};

const switchMap = {};

switchMap[types.INIT] = (state) =>
  update(state, {
    $set: initialState,
  });

switchMap[types.SET_DIMENSIONS] = (state, action) =>
  update(state, {
    dimensions: {
      $set: action.dimensions,
    },
  });

switchMap[types.SET_DIMENSION] = (state, action) =>
  update(state, {
    dimensions: {
      $splice: [[action.index, 1, action.dimension]],
    },
  });

switchMap[types.SWITCH_DIMENSION] = (state, action) => {
  const dimensions = [...state.dimensions];
  const { index, target } = action;
  const tempDimension = dimensions[index];
  dimensions[index] = dimensions[target];
  dimensions[target] = tempDimension;
  return update(state, {
    dimensions: {
      $set: dimensions,
    },
  });
};

switchMap[types.SET_UNIT] = (state, action) =>
  update(state, {
    unit: {
      $set: action.unit,
    },
  });

switchMap[types.SET_DIMENSION_TABLES_STATE] = (state, action) =>
  update(state, {
    $merge: action.state,
  });

export default (state = initialState, action) =>
  switchMap[action.type] ? switchMap[action.type](state, action) : state;
